import { EventListItem } from 'components/EventsSidebar'
import { EventSummary } from 'types/api'

const DATE_OPTS: Intl.DateTimeFormatOptions = { month: 'short', day: '2-digit', year: 'numeric' }

export const eventSummaryToListItem = (e: EventSummary): EventListItem => ({
  eventId: e.eventId,
  name: e.name,
  date: new Date(e.startedAt ?? e.createdAt).toLocaleDateString(undefined, DATE_OPTS),
  status: e.status as EventListItem['status']
})
